import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaSelectOptionList from './VaSelectOptionList.vue'

export const VaSelectOptionList = withConfigTransport(_VaSelectOptionList)
